import React from 'react';
import {connect} from 'react-redux';
import Moment from 'react-moment';
import { getSafe } from '../../helpers/utils';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import BooleanToString from '../../helpers/BooleanToString';

function FlightPreview ({ guest, currentLanguage }) {

	const langCode = currentLanguage?.code ? currentLanguage.code : 'en';

	return (
		<>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="flight-outbound" fallback="Departure Flight" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="travel-flight" fallback="Flight" textOnly/></p>
						<div>
							<p>{getSafe(() => guest.outbound_flight.flight_number, 'n/a, ')}</p>
							<p>{getSafe(() => guest.outbound_flight.airline, 'n/a')}</p>
						</div>
					</div>
					<hr/>
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="word-from" fallback="From" textOnly/></p>
						<div>
							<p className="mr-2">{getSafe(() => guest.outbound_flight.departure_location, 'n/a')}, {getSafe(() => guest.outbound_flight.departure_terminal, 'n/a')}</p>
							<p>
								<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.outbound_flight.departure_date, 'n/a')}</Moment>
								{` at `}
								<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.outbound_flight.departure_time, 'n/a')}</Moment>
							</p>
						</div>
					</div>
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="word-to" fallback="To" textOnly/></p>
						<div>
							<p className="mr-2">{getSafe(() => guest.outbound_flight.arrival_location, 'n/a')}, {getSafe(() => guest.outbound_flight.arrival_terminal, 'n/a')}</p>
							<p>
								<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.outbound_flight.arrival_date, 'n/a')}</Moment>
								{` at `}
								<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.outbound_flight.arrival_time, 'n/a')}</Moment>
							</p>
						</div>
					</div>
					<hr/>
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="flight-stopovers" fallback="Stopovers" textOnly/></p>
						<div>
							<p>{getSafe(() => guest.outbound_flight.stopovers, 'n/a')}</p>
							<p className="mt-4 w-100 d-block">{getSafe(() => guest.outbound_flight.comments)}</p>
						</div>
					</div>
					<hr/>
				</div>
			</div>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="flight-transfer-needed" fallback="Need trasfer?" textOnly/></label>
				</div>
                <div className="col-lg-8 col-12">
                    <p>
                        <BooleanToString condition={guest.outbound_flight.airport_transfer_to_city}/>
                    </p>
                </div>
			</div>
			<hr/>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="flight-inbound" fallback="Arrival Flight" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="travel-flight" fallback="Flight" textOnly/></p>
						<div>
							<p>{getSafe(() => guest.inbound_flight.flight_number, 'n/a, ')}</p>
							<p>{getSafe(() => guest.inbound_flight.airline, 'n/a')}</p>
						</div>
					</div>
					<hr/>
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="word-from" fallback="From" textOnly/></p>
						<div>
							<p className="mr-2">{getSafe(() => guest.inbound_flight.departure_location, 'n/a')}, {getSafe(() => guest.inbound_flight.departure_terminal, 'n/a')}</p>
							<p>
								<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.inbound_flight.departure_date, 'n/a')}</Moment>
								{` at `}
								<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.inbound_flight.departure_time, 'n/a')}</Moment>
							</p>
						</div>
					</div>
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="word-to" fallback="To" textOnly/></p>
						<div>
							<p className="mr-2">{getSafe(() => guest.inbound_flight.arrival_location, 'n/a')}, {getSafe(() => guest.inbound_flight.arrival_terminal, 'n/a')}</p>
							<p>
								<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.inbound_flight.arrival_date, 'n/a')}</Moment>
								{` at `}
								<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.inbound_flight.arrival_time, 'n/a')}</Moment>
							</p>
						</div>
					</div>
					<hr/>
					<div className="flex-gap flex-nowrap">
						<p className="font-weight-bold text-uppercase col-md-3 col-12 p-0"><TextTranslate name="flight-stopovers" fallback="Stopovers" textOnly/></p>
						<div>
							<p>{getSafe(() => guest.inbound_flight.stopovers, 'n/a')}</p>
							<p className="mt-4 w-100 d-block">{getSafe(() => guest.inbound_flight.comments)}</p>
						</div>
					</div>
					<hr/>
				</div>
			</div>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="flight-transfer-needed" fallback="Need trasfer?" textOnly/></label>
				</div>
                <div className="col-lg-8 col-12">
                    <p>
                        <BooleanToString condition={guest.inbound_flight.airport_transfer_to_city}/>
                    </p>
                </div>
			</div>
		</>
	)
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(FlightPreview);
